import { styleConstants } from '@paywithextend/components'
import {
  base_colorAction,
  base_colorContentBorder,
  base_colorSurface,
  tag_colorTagPendingBackground,
  text_colorTextPrimary,
  text_colorTextSecondary,
  warning_border,
  warning_text,
} from 'ext-ui/style/colors'
import { css } from 'styled-components'

// Literal port of prototypes/extend-downgrade GateModal +
// DowngradeGate + InlineAlert. All values mirror the prototype's
// text-styles.css and inline style values 1:1.
export default css`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;

  .CancelSubscriptionDowngrade-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .CancelSubscriptionDowngrade-text {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  /* text-heading-h3: Rubik / 20 / 500 / 24 / letter-spacing 0 */
  .CancelSubscriptionDowngrade-header {
    font-family: ${styleConstants.fontFamilies.medium};
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;
    letter-spacing: 0;
    color: ${text_colorTextPrimary};
    margin: 0;
  }

  /* text-paragraph-support-text-regular: Rubik / 14 / 400 / 18 / 0 */
  .CancelSubscriptionDowngrade-body-text {
    font-family: ${styleConstants.fontFamilies.regular};
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    letter-spacing: 0;
    color: ${text_colorTextPrimary};
    margin: 0;
  }

  /* Over-cap action row — base/color-surface with 1px content-border
     per Figma node 23739:56749. */
  .CancelSubscriptionDowngrade-manage-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 14px;
    border-radius: 8px;
    border: 1px solid ${base_colorContentBorder};
    background: ${base_colorSurface};
    text-decoration: none;
    color: inherit;
  }

  /* text-paragraph-microcopy-regular: Rubik / 12 / 400 / 16 / 0 */
  .CancelSubscriptionDowngrade-manage-card-text {
    font-family: ${styleConstants.fontFamilies.regular};
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: 0;
    color: ${text_colorTextSecondary};
    margin: 0;
  }

  /* Inline-button styled link "Manage Cards →" — Rubik / 14 / 500 / 18 / 0,
     cta blue. Matches prototype Button variant="inline" base type. */
  .CancelSubscriptionDowngrade-manage-card-cta {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-family: ${styleConstants.fontFamilies.medium};
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    letter-spacing: 0;
    color: ${base_colorAction};
    flex-shrink: 0;
    white-space: nowrap;

    svg {
      width: 16px;
      height: 16px;
      path {
        fill: ${base_colorAction};
      }
    }
  }

  /* InlineAlert — exact port of prototype. 1px yellow-200 border,
     yellow tag-pending bg, yellow-800 text, microcopy 12/16. */
  .CancelSubscriptionDowngrade-warning {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 16px 20px;
    border-radius: 8px;
    background: ${tag_colorTagPendingBackground};
    border: 1px solid ${warning_border};
    width: 100%;
  }

  .CancelSubscriptionDowngrade-warning-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: ${warning_text};
  }

  /* Wraps DeactivationNotice; sets the inherited yellow text color. */
  .CancelSubscriptionDowngrade-warning-text {
    flex: 1;
    color: ${warning_text};
  }

  .CancelSubscriptionDowngrade-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    /* Cancel = ext-ui variant="text" — plain link, secondary color. */
    .Button.text {
      color: ${text_colorTextSecondary};

      & g {
        fill: ${text_colorTextSecondary};
      }
    }
  }
`
